import Button from './Button'

const Ranking = ({ name, surname, ranking, score, photo }) => {
  return (
    <div className="relative grid grid-rows-2 auto-rows-auto">
      <div className="lg:relative bg-accent">
        <div className="max-w-7xl mx-auto pt-16 lg:pt-32">
          <div className="px-4 pb-4 sm:px-16 lg:px-0 sm:pb-16 lg:w-1/2 xl:pr-16 max-w-2xl">
            <h1 className="text-4xl tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-8xl">
              <span className="block xl:inline">
                {name} {surname}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div className="lg:relative bg-blue">
        <div className="max-w-7xl mx-auto py-16 lg:text-left">
          <div className="flex">
            <div className="px-4 pt-4 sm:px-16 lg:px-0 xl:pr-16">
              <p className="mt-3 text-accent text-lg">Rànquing</p>
              <p className="mt-3 max-w-md text-white text-3xl sm:text-5xl md:mt-2 md:max-w-3xl">
                {ranking}
              </p>
            </div>
            <div className="px-4 pt-4 sm:px-16 xl:pr-16">
              <p className="mt-3 text-accent text-lg">Punts</p>
              <p className="mt-3 max-w-md text-white text-3xl sm:text-5xl md:mt-2 md:max-w-3xl">
                {score}
              </p>
            </div>
          </div>
          {/* <div className="px-4 pt-8 sm:px-16 lg:w-1/2 xl:pr-16 flex">
            <Button link="/" text="Veure perfil" size="small" />
          </div> */}
        </div>
      </div>
      {photo && (
        <div className="h-full w-full xl:w-auto absolute right-0">
          <div className="h-full flex flex-wrap items-center justify-center mr-16">
            <img
              src={photo}
              className="object-cover w-[150px] h-[150px] xl:w-[663px] xl:h-[663px] rounded-full"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Ranking
